export var nullContentBlock = {
    key: 'foo',
    text: '',
    type: 'unstyled',
    depth: 0,
    inlineStyleRanges: [],
    entityRanges: [],
    data: {}
};
export var getNormalizedContentBlocks = function (blocks) {
    if (!blocks || !blocks.length) {
        return [nullContentBlock];
    }
    // Trim all empty blocks at the start and end of the content
    var isEmptyBlocks = blocks.map(function (block) {
        return isEmptyBlock(block);
    });
    var firstNonEmptyIdx = isEmptyBlocks.indexOf(false);
    var lastNonEmptyIdx = isEmptyBlocks.lastIndexOf(false);
    return firstNonEmptyIdx !== -1
        ? blocks.slice(firstNonEmptyIdx, lastNonEmptyIdx + 1)
        : [nullContentBlock];
};
function isEmptyBlock(block) {
    return (block.text.replace(/\s+/gm, '') === '' &&
        block.type === 'unstyled' &&
        block.inlineStyleRanges.length === 0 &&
        block.entityRanges.length === 0);
}
//# sourceMappingURL=editorNormilizeBlocks.js.map